import { useState } from 'react';
import { getWaitlistApiUrl } from '../utils/environment';
import { trackWaitlistSubmitted, trackWaitlistSucceeded } from '../utils/analytics';

// status: 'idle' | 'submitting' | 'success' | 'error'
const Waitlist = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();

    if (!isValidEmail(trimmed)) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    const apiUrl = getWaitlistApiUrl();
    if (!apiUrl) {
      setStatus('error');
      setMessage('Waitlist is not configured yet. Please check back shortly.');
      return;
    }

    setStatus('submitting');
    setMessage('');
    trackWaitlistSubmitted('waitlist_section');

    try {
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: trimmed, source: 'agents.solidly.ai' }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        setStatus('success');
        setMessage(
          data.alreadyOnList
            ? 'You’re already on the list — we’ll be in touch soon.'
            : 'Done — the demo is on its way. Check your inbox.'
        );
        trackWaitlistSucceeded('waitlist_section');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Network error. Please try again in a moment.');
    }
  };

  return (
    <section className="waitlist" id="waitlist">
      <div className="waitlist-glow" aria-hidden="true" />
      <div className="section-container waitlist-inner">
        <p className="overline overline--center">STAY IN THE LOOP</p>
        <h2 className="section-title">Not ready to buy today?</h2>
        <p className="section-subtitle">
          Leave your email and we’ll send you the 3-minute demo, a note when the macOS build
          ships, and a heads-up before launch pricing ends. Nothing else.
        </p>

        {status === 'success' ? (
          <div className="waitlist-success" role="status">
            <span className="waitlist-success-check" aria-hidden="true">
              ✓
            </span>
            <p>{message}</p>
          </div>
        ) : (
          <form className="waitlist-form" onSubmit={handleSubmit} noValidate>
            <input
              type="email"
              className="waitlist-input"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }}
              aria-label="Email address"
              autoComplete="email"
              disabled={status === 'submitting'}
            />
            <button type="submit" className="btn btn-primary" disabled={status === 'submitting'}>
              {status === 'submitting' ? 'Sending…' : 'Send me the demo →'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="waitlist-message waitlist-message--error" role="alert">
            {message}
          </p>
        )}

        <p className="waitlist-fineprint">
          One or two emails total. Unsubscribe anytime — we only store your email to send these.
        </p>
      </div>
    </section>
  );
};

export default Waitlist;
